/**
 * NCM ou serviço importado como rascunho (sugestão pelo CNAE na consulta de
 * CNPJ) nasce só com o código. Estas regras dizem o que falta para ele poder
 * entrar numa nota — espelho de `common/utils/parametrizacao.util.ts` do
 * nf-server, que usa as mesmas regras para bloquear a emissão.
 */

interface NcmLike {
  tributos?: {
    icms?: { origem?: string | null; cst?: string | null } | null;
    pis?: { cst?: string | null } | null;
    cofins?: { cst?: string | null } | null;
  } | null;
}

interface ServicoLike {
  codigo?: string | null;
  discriminacao?: string | null;
  iss?: { aliquota?: number | string | null } | null;
}

const isBlank = (value: unknown) =>
  value === null ||
  value === undefined ||
  (typeof value === "string" && value.trim() === "");

export function ncmCamposFaltantes(ncm: NcmLike | null | undefined): string[] {
  const faltantes: string[] = [];
  const tributos = ncm?.tributos;

  if (isBlank(tributos?.icms?.origem)) faltantes.push("origem do ICMS");
  if (isBlank(tributos?.icms?.cst)) faltantes.push("CST/CSOSN do ICMS");
  if (isBlank(tributos?.pis?.cst)) faltantes.push("CST do PIS");
  if (isBlank(tributos?.cofins?.cst)) faltantes.push("CST do COFINS");

  return faltantes;
}

export function isNcmParametrizado(ncm: NcmLike | null | undefined): boolean {
  return ncmCamposFaltantes(ncm).length === 0;
}

export function servicoCamposFaltantes(
  servico: ServicoLike | null | undefined
): string[] {
  const faltantes: string[] = [];

  if (isBlank(servico?.codigo)) faltantes.push("código do serviço");
  if (isBlank(servico?.discriminacao)) faltantes.push("discriminação");

  const aliquota = servico?.iss?.aliquota;
  if (isBlank(aliquota) || Number.isNaN(Number(aliquota))) {
    faltantes.push("alíquota do ISS");
  }

  return faltantes;
}

export function isServicoParametrizado(
  servico: ServicoLike | null | undefined
): boolean {
  return servicoCamposFaltantes(servico).length === 0;
}

export function joinFaltantes(faltantes: string[]): string {
  if (faltantes.length <= 1) return faltantes.join("");
  return `${faltantes.slice(0, -1).join(", ")} e ${
    faltantes[faltantes.length - 1]
  }`;
}
